import * as React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import HomeTabNavigator from './HomeTabNavigator';

import CategoryScreen from '../screens/product/Category';
import CategoryProductScreen from '../screens/product/CategoryProduct';

import ManufacturerProductScreen from '../screens/product/ManufacturerProduct';
import ManufacturerBrandScreen from '../screens/product/ManufacturerBrand';

import BrandScreen from '../screens/product/Brand';
import BrandProductScreen from '../screens/product/BrandProduct';

import SearchProductScreen from '../screens/product/SearchProduct';
import ProductScreen from '../screens/product/Product';

const Stack = createStackNavigator();
const INITIAL_ROUTE_NAME = 'HomeTab';

export default function HomeNavigator() {

  return (
    <Stack.Navigator initialRouteName={INITIAL_ROUTE_NAME} headerMode="none">
      <Stack.Screen
        name="HomeTab"
        component={HomeTabNavigator}
      />

      {/* list all brands of manufacturer /manufacturer/:id */}
      <Stack.Screen
        name="ManufacturerBrand"
        component={ManufacturerBrandScreen}
      />
      {/* list all products of manufacturer /manufacturer/:id/product */}
      <Stack.Screen
        name="ManufacturerProduct"
        component={ManufacturerProductScreen}
      />

      {/* list all brands /brand */}
      {/* <Stack.Screen
        name="Brand"
        component={BrandScreen}
      /> */}
      
      {/* list all products of a brand /brand/:id */}
      <Stack.Screen
        name="BrandProduct"
        component={BrandProductScreen}
      />
      {/* list products of a category /category/:id */}
      <Stack.Screen
        name="CategoryProduct"
        component={CategoryProductScreen}
      />
      {/* search in all product props /search?q=xyz */}
      {/* <Stack.Screen
        name="SearchProduct"
        component={SearchProductScreen}
      /> */}
      {/* list all products and history /products */}
      {/* <Stack.Screen
        name="Product"
        component={ProductScreen}
      /> */}
    </Stack.Navigator>
  );
}

